// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-module--base--2Mdwj","bg":"styles-module--bg--2Tt6f","content":"styles-module--content--d3x8p","heading":"styles-module--heading--2BJUC"};